import { FunctionComponent } from 'react'

import styled, { css, useTheme } from 'styled-components'

import useUser from '@hooks/useUser'
import IconButton from '@components/Buttons/IconButton'
import ProgressBar from '@components/ProgressBar'

interface HeaderProps {
  onClose: (buttonText: string) => void
  steps: string[]
  currentStepIndex: number
}

const StyledWrapper = styled.div`
  ${({
    theme: {
      spacing: { spacing24, spacing8 },
    },
  }) => css`
    display: flex;
    flex-direction: column;
    padding: 0 ${spacing8};
    gap: ${spacing24};
    justify-content: center;
  `}
`

const StyledEmailWrapper = styled.div`
  ${({
    theme: {
      spacing: { spacing8 },
    },
  }) => css`
    display: flex;
    flex-direction: row;
    gap: ${spacing8};
    align-items: center;
    justify-content: flex-end;
  `}
`

const StyledEmail = styled.span`
  ${({
    theme: {
      colors: { textDefault },
      typography: {
        bodycopy: {
          xxsmall: { bundledCSS: xxsmallBodyCopyCSS },
        },
      },
    },
  }) => css`
    color: ${textDefault};
    ${xxsmallBodyCopyCSS};
    flex-grow: 1;
  `}
`

const Header: FunctionComponent<HeaderProps> = ({
  onClose,
  steps,
  currentStepIndex,
}) => {
  const user = useUser()
  const email = user?.email
  const theme = useTheme()
  return (
    <StyledWrapper>
      <StyledEmailWrapper>
        {email && <StyledEmail>{email}</StyledEmail>}
        <IconButton
          ariaLabel="Onboarding Modal Close"
          onClick={() => onClose('x')}
          iconName="xmark-large"
          iconSize={24}
          iconColor={theme.colors.iconDefault}
          buttonSize={24}
        />
      </StyledEmailWrapper>
      <ProgressBar steps={steps} currentStepIndex={currentStepIndex} />
    </StyledWrapper>
  )
}

export default Header
